(function () {
  function fixHeroStoryLink() {
    var storyLink = document.querySelector('.hero-collage-link');
    var isFrench = document.documentElement.lang.toLowerCase().indexOf('fr') === 0;
    if (storyLink) storyLink.href = isFrench ? '/fr/pages/about' : '/pages/about';
  }

  function updateNorthAmericaMarketingCopy() {
    var heroEyebrow = document.querySelector('.hero-collage-text .eyebrow-label');
    var isFrench = document.documentElement.lang.toLowerCase().indexOf('fr') === 0;
    if (heroEyebrow) {
      heroEyebrow.textContent = isFrench
        ? 'Des outils de santé pour les soins quotidiens'
        : 'Home health tools for everyday care';
    }

    var tickerItems = document.querySelectorAll('.trust-ticker__group span');
    tickerItems.forEach(function (item) {
      if (item.textContent.trim() === 'Health Canada approved') {
        item.textContent = 'Health Canada & US FDA approved';
      }
    });
  }

  function setupBestsellerReveal() {
    var band = document.querySelector('.bs-band');
    if (!band || band.classList.contains('bs-home-static')) return;

    var isUsMarket = window.Shopify && window.Shopify.country === 'US';

    var head = band.querySelector('.bs-band__head');
    if (head && !head.querySelector('.bs-band__head-copy')) {
      var headCopy = document.createElement('div');
      headCopy.className = 'bs-band__head-copy';

      while (head.firstChild) {
        headCopy.appendChild(head.firstChild);
      }

      var heading = headCopy.querySelector('.bs-band__heading');
      var intro = headCopy.querySelector('.bs-band__intro');
      if (heading) heading.innerHTML = 'Our <em>best</em><br>sellers.';
      if (intro) {
        intro.textContent =
          'The four pieces families reach for again and again — chosen for their precision, simplicity, and quiet reliability.';
      }

      var shopAll = document.createElement('a');
      shopAll.className = 'bs-band__shop-all';
      shopAll.href = '/collections/shop';
      shopAll.innerHTML =
        'Shop all <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>';

      head.appendChild(headCopy);
      head.appendChild(shopAll);
    }

    var feature = band.querySelector('.bs-feature');
    if (feature) {
      var featureTitle = feature.querySelector('.bs-feature__title');
      var featureDescription = feature.querySelector('.bs-feature__desc');
      var featureSku = feature.querySelector('.bs-feature__sku');
      var featureView = feature.querySelector('.bs-feature__view');

      if (featureTitle) featureTitle.innerHTML = 'Color-changing display. <em>Calm in any room.</em>';
      if (featureDescription) featureDescription.textContent = 'Color-changing display · fever glow alarm';
      if (featureSku) featureSku.textContent = 'PG-IRT1602';
      if (featureView) {
        featureView.innerHTML =
          'Discover <svg class="bs-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>';
      }
    }

    if (isUsMarket) {
      var miniCards = band.querySelectorAll('.bs-mini');
      var usCopy = [
        {
          category: 'Upper-arm blood pressure monitor',
          description: 'Clear, color-guided readings with a comfortable cuff for everyday home monitoring.',
        },
        {
          category: 'Digital heart rate monitor',
          description: 'Fast blood pressure and pulse readings on a large, easy-to-read display.',
        },
        {
          category: 'Non-touch forehead thermometer',
          description: 'Quick, contact-free temperature checks for adults and children with an easy-to-read display.',
        },
      ];

      miniCards.forEach(function (card, index) {
        if (!usCopy[index]) return;
        var category = card.querySelector('.bs-mini__cat');
        var description = card.querySelector('.bs-mini__desc');
        if (category) category.textContent = usCopy[index].category;
        if (description) description.textContent = usCopy[index].description;
      });
    }

    band.classList.add('bs-home-static');

    if (
      !('IntersectionObserver' in window) ||
      (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
    ) {
      band.classList.add('bs-home-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting) return;

        window.setTimeout(function () {
          window.requestAnimationFrame(function () {
            band.classList.add('bs-home-visible');
          });
        }, 240);
        observer.disconnect();
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -18% 0px',
      }
    );

    observer.observe(band);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      fixHeroStoryLink();
      updateNorthAmericaMarketingCopy();
      setupBestsellerReveal();
    });
  } else {
    fixHeroStoryLink();
    updateNorthAmericaMarketingCopy();
    setupBestsellerReveal();
  }
})();
